import React from 'react'
import { currentYear } from '../utils/common'

const Footer = () => (
  <footer className="footer">
    <div className="pure-g">
      <div className="pure-u-1 pure-u-md-2-3">
        <p className="copyright">
          <a
            href="/contactus/"
            style={{
              marginRight: '0.2rem',
            }}
          >
            联系我们
          </a>
          © {currentYear()} 一楼一凤 161F
        </p>
      </div>
    </div>
  </footer>
)

export default Footer
